import tw, { styled, css } from 'twin.macro'

const requiredStyle = css`
  &::after {
    content: ' *';
    ${tw`text-secondary-close`}
  }
`

type Props = {
  $required: boolean
}

const Label = styled.span<Props>`
  ${tw`text-black text-c1-d leading-c1-d`};
  ${(props) => props.$required && requiredStyle}
`

export default Label
